import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Guid } from 'guid-typescript';
import { UserCacheService } from '../../../common/services/user-cache.service';
import { DataService } from '../../services/data.service';
import { AppConstants } from './../../constants/app-constants';
import { SaeLoginService } from './sae-login.service';
import { FwcHero } from '../../../../fwc-lib.js';
import { SAEBaseComponent } from '../../../common/components/sae-base.component';
import { WcsApiService } from '../../../common/services/wcs-api-service';
import { FwcTooltip } from '../../../../fwc-lib.js';
import { ValidatorService } from '../../services/validator.service';
// TODO: ADD FORM ERROR CONTENT AND LOGIC
@Component({
    selector: 'sae-login',
    templateUrl: './sae-login.component.html',
    styleUrls: ['./sae-login.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SaeLoginComponent extends SAEBaseComponent implements OnInit {
  @Input() content: any;
  @Output() updateUsercache: EventEmitter<any> = new EventEmitter<any>();
  loginForm!: UntypedFormGroup;
  submitted = false;
  contents: any;
  masked = true;
  loginOutput = {
    userId: '',
    email: ''
  };
  participantId: string = null;
  storyId: string = null;
  displaySpinner: boolean = false;
  errorMsg: string = '';

  constructor(
    private formBuilder: UntypedFormBuilder,
    public saeLoginService: SaeLoginService,
    public router: Router,
    private dataService: DataService,
    private route: ActivatedRoute,
    public userCacheService: UserCacheService,
    public wcsApiService: WcsApiService,
    public validatorSvc: ValidatorService
  ) {
    super(wcsApiService);
    const fwcHero = new FwcHero();
    fwcHero.build();
    const fwcTooltip = new FwcTooltip();
    fwcTooltip.build();
    this.participantId = this.userCacheService.getUserData(AppConstants.PARTICIPATION_ID) || parseInt(this.route.snapshot.paramMap.get('id'));
    this.storyId = this.userCacheService.getUserData(AppConstants.STORY_ID) || this.route.snapshot.paramMap.get('storyId');
  }

  async ngOnInit(): Promise<void> {
    this.loginForm = this.formBuilder.group({
      email: ['', [Validators.required, this.validatorSvc.emailValidation()]]
    });
    await this.loadWCSData('login');
    if (this.wcsdata) {
      this.contents = this.wcsdata;
    }
  }
  get form(): { [p: string]: AbstractControl } { return this.loginForm.controls; }

  onSubmit(): void {
    // this.dataService.doAnnouncement({topic: AppConstants.LOGIN_FAILED, message:null});
    this.dataService.doAnnouncement(null);
    // const id = Guid.create();
    // this.loginOutput.clientCorrelationId = id.toString();
    this.submitted = true;
    if (this.loginForm.valid) {
      const formValues = this.loginForm.value;
      const email = formValues.email || '';
      if (!email) {
        this.errorMsg = this.content?.errorMessages?.emailError || 'Email is required';
        return;
      }
      this.displaySpinner = true;
      this.saeLoginService.getUserId(email).subscribe({
        next: (response: any) => {
          this.displaySpinner = false;
          if (response && response.status === 'SUCCESS' && response.token) {
            const userId = atob(response.token);
            this.loginOutput.userId = userId;
            this.loginOutput.email = email;
            this.updateUsercache.emit(this.loginOutput);
          } else {
            this.errorMsg = this.content?.errorMessages?.userError || 'Failed to get user ID';
          }
        },
        error: (error: any) => {
          this.displaySpinner = false;
          this.errorMsg = this.content?.errorMessages?.userError || 'Failed to get user ID';
        }
      });
    }
  }
  navigateTo(path): void {
    this.router.navigate([path]);
  }

  onKey(e): void {
    const regxStr = new RegExp('^[0-9a-zA-Z$!@*?|]*$');
    if (!regxStr.test(e.key)) {
      e.preventDefault();
    }
  }

}
